import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import AbstractCmsElement from './AbstractCmsElementNew';


export default class CmsElementRaw extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  render() {
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-raw ' + shownClass + this.getResponsiveClasses() + this.getCssClasses()}
        style={{
          ...this.getBackgroundStyle(),
        }}
      >
        {this.getElementStyle()}

        {this.getParamValue('content')}

        {this.getAppendHtml()}
      </div>
    );

    const cmsOverflowFix = parallaxData ? 'cms-overflow-fix' : '';

    return (
      <>
        <CustomScrollTrigger className={cmsOverflowFix} onEnter={this.shown}>
          {parallaxData ? <Parallax {...parallaxData}>{innerContent}</Parallax> : innerContent}
        </CustomScrollTrigger>
      </>
    );
  }
}
CmsElementRaw.defaultProps = {
  index: '0',
};
